import { createStore } from 'zustand/vanilla';
import type { NotificacaoDto } from '@nexital/shared';
import type { ApiNotificacoes } from './portas';

export type EstadoNotificacoes = {
  naoLidas: number;
  notificacoes: NotificacaoDto[];
  carregar(): Promise<void>;
  /** Aviso novo pelo tempo real: entra no topo e conta como não lido. */
  receber(notificacao: NotificacaoDto): void;
  /** Sem lista, todas. */
  marcarLidas(uuids?: string[]): Promise<void>;
  /** Post-it que o aviso aberto pede para mostrar (RQ-NOT-011); o quadro que o desenha centraliza e limpa. */
  notaEmFoco: string | null;
  focarNota(uuid: string | null): void;
};

const LIMITE = 50;

/** Entra no topo (sem repetir o que já está na lista) e conta como não lida. */
function comNova(s: EstadoNotificacoes, n: NotificacaoDto): Partial<EstadoNotificacoes> {
  if (s.notificacoes.some((x) => x.uuid === n.uuid)) return s;
  return { notificacoes: [n, ...s.notificacoes].slice(0, LIMITE), naoLidas: s.naoLidas + (n.lidaEm ? 0 : 1) };
}

/** Avisos da pessoa conectada (RQ-NTF-001): o sino da barra superior. */
export function criarStoreNotificacoes(api: ApiNotificacoes) {
  return createStore<EstadoNotificacoes>()((setState, getState) => ({
    naoLidas: 0,
    notificacoes: [],
    carregar: async () => {
      try {
        setState(await api.obterNotificacoes());
      } catch {
        // Sem avisos na tela; a próxima chegada pelo tempo real ou a próxima carga tentam de novo.
      }
    },
    receber: (n) => setState((s) => comNova(s, n)),
    marcarLidas: async (uuids) => {
      const agora = new Date().toISOString();
      const alvo = (n: NotificacaoDto) => !n.lidaEm && (!uuids || uuids.includes(n.uuid));
      const marcadas = getState().notificacoes.filter(alvo).length;
      const notificacoes = getState().notificacoes.map((n) => (alvo(n) ? { ...n, lidaEm: agora } : n));
      setState((s) => ({ notificacoes, naoLidas: uuids ? Math.max(0, s.naoLidas - marcadas) : 0 }));
      await api.marcarNotificacoesLidas(uuids).catch(() => undefined);
    },
    notaEmFoco: null,
    focarNota: (notaEmFoco) => setState({ notaEmFoco }),
  }));
}

export type StoreNotificacoes = ReturnType<typeof criarStoreNotificacoes>;
